import React, { Component } from 'react'
import SyncedStore from '../../../stores/SyncedStore'
import { Button, Header, Table } from 'semantic-ui-react'
import LoadingWrapper from '../../../components/LoadingWrapper'
import { Link, withRouter } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import ModalError from '../../../components/ModalError'
import PropTypes from 'prop-types'

@inject('syncedStore')
@withRouter
@observer
class ClientsSyncedImportScreen extends Component {
  static propTypes = {
    syncedStore: PropTypes.instanceOf(SyncedStore),
    match: PropTypes.object,
    history: PropTypes.object,
    location: PropTypes.object
  }

  constructor (props) {
    super(props)
    if (!props.match.params.clientId) {
      props.history.goBack()
    }
    this.search = new URLSearchParams(props.location.search).get('highlight')
    window.document.title = 'Détails du client'
  }

  componentDidMount () {
    const { syncedStore, match } = this.props
    syncedStore.loadOne(match.params.clientId)
  }

  handleImport = () => {
    const { syncedStore, match, history } = this.props
    syncedStore.import(match.params.clientId).then(result => {
      history.push(`/clients/view/${result.client.id}`)
    })
  }

  render () {
    const { syncedStore } = this.props
    const { syncedList, isLoading } = syncedStore
    return (
      <>
        <LoadingWrapper loading={isLoading} message='Chargement en cours...' />
        <ModalError store={syncedStore} />
        <Header as='h2'>Client principal</Header>
        <Table celled>
          <Table.Header key='header1'>
            <Table.Row>
              <Table.HeaderCell>Code</Table.HeaderCell>
              <Table.HeaderCell>Nom</Table.HeaderCell>
              <Table.HeaderCell>Contact</Table.HeaderCell>
              <Table.HeaderCell>Adresse</Table.HeaderCell>
              <Table.HeaderCell>Téléphone</Table.HeaderCell>
              <Table.HeaderCell>Télécopieur</Table.HeaderCell>
              <Table.HeaderCell>Courriel</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body key='body1'>
            {syncedList.map(synced => {
              return (
                <Table.Row key={`syncedMain_${synced.PK_Number}`}>
                  <Table.Cell>
                    {synced.PK_Number}
                  </Table.Cell>
                  <Table.Cell>
                    {synced.CuName}
                  </Table.Cell>
                  <Table.Cell>
                    {synced.CuCareOf}
                  </Table.Cell>
                  <Table.Cell>
                    {synced.fullAddress}
                  </Table.Cell>
                  <Table.Cell>
                    {synced.CuPhoneNumber1}
                  </Table.Cell>
                  <Table.Cell>
                    {synced.CuPhoneNumber2}
                  </Table.Cell>
                  <Table.Cell>
                    {synced.CuEmail}
                  </Table.Cell>
                </Table.Row>
              )
            })}
          </Table.Body>
        </Table>
        {(!!syncedList.length && !!syncedList[0].clients_childs_synced.length) && (
          <>
            <Header as='h2'>Adresses Suplémentaires</Header>
            <Table celled>
              <Table.Header key='header2'>
                <Table.Row>
                  <Table.HeaderCell>Code</Table.HeaderCell>
                  <Table.HeaderCell>Nom</Table.HeaderCell>
                  <Table.HeaderCell>Contact</Table.HeaderCell>
                  <Table.HeaderCell>Adresse</Table.HeaderCell>
                  <Table.HeaderCell>Téléphone</Table.HeaderCell>
                  <Table.HeaderCell>Télécopieur</Table.HeaderCell>
                  <Table.HeaderCell>Courriel</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body key='body2'>
                {!!syncedList.length && syncedList[0].clients_childs_synced.map(synced => {
                  return (
                    <Table.Row
                      key={`syncedMain_${synced.PK_Number}`}
                      active={this.search === synced.PK_Number}
                    >
                      <Table.Cell>
                        {synced.PK_Number}
                      </Table.Cell>
                      <Table.Cell>
                        {synced.CuName}
                      </Table.Cell>
                      <Table.Cell>
                        {synced.CuCareOf}
                      </Table.Cell>
                      <Table.Cell>
                        {synced.fullAddress}
                      </Table.Cell>
                      <Table.Cell>
                        {synced.CuPhoneNumber1}
                      </Table.Cell>
                      <Table.Cell>
                        {synced.CuPhoneNumber2}
                      </Table.Cell>
                      <Table.Cell>
                        {synced.CuEmail}
                      </Table.Cell>
                    </Table.Row>
                  )
                })}
              </Table.Body>
            </Table>
          </>)}
        {!!syncedList.length && syncedList[0].client
          ? (
            <Button as={Link} to={`/clients/view/${syncedList[0].client.id}`}>Voir client</Button>)
          : (
            <Button onClick={this.handleImport} primary>Importer</Button>)}
      </>
    )
  }
}

export default ClientsSyncedImportScreen
